import { icons } from '@lifebit-ai/lds'
import React from 'react'

import { type CheckboxFormField, type FieldComponentProps } from './fieldTypes'
import { renderFieldHelpText } from './HelpText'
import * as styles from './ViewFormModal.styles'

export const CheckboxField = ({ field }: FieldComponentProps<CheckboxFormField>) => {
  return (
    <styles.TextField>
      <styles.CheckboxField>
        <styles.CheckboxIcon>{field.isChecked && <icons.CheckInCircleSmall />}</styles.CheckboxIcon>
        <styles.CheckboxFieldText>{field.label}</styles.CheckboxFieldText>
      </styles.CheckboxField>
      {renderFieldHelpText(field.helpText)}
    </styles.TextField>
  )
}
